module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.28316",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9479",
      "ably-hubspot-js": "static-2.4516",
      "atom": "static-1.4869",
      "conversations-async-data": "static-2.7462",
      "conversations-error-reporting": "static-1.8676",
      "conversations-internal-pub-sub": "static-1.15766",
      "conversations-internal-schema": "static-1.12482",
      "conversations-message-history": "static-1.12024",
      "conversations-test-sdk": "static-1.10298",
      "conversations-visitor-experience-components": "static-1.21679",
      "head-dlb": "static-1.4841",
      "hs-promise-utils": "static-1.5393",
      "hs-test-utils": "static-1.7806",
      "hubspot-dlb": "static-2.1806",
      "HubStyleTokens": "static-2.11228",
      "I18n": "static-7.1569",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2818",
      "jasmine-runner": "static-1.6273",
      "quartz": "static-1.6737",
      "react-dlb": "static-1.71",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.60",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4274",
      "StyleGuideUI": "static-3.483",
      "transmute": "static-2.85",
      "urlinator": "static-1.4333",
      "usage-tracker": "static-1.7135",
      "usage-tracker-core": "static-1.6985",
      "usage-tracker-public": "static-1.6946",
      "viral-links-lib": "static-1.6834",
      "visitor-ui-component-library": "static-1.5931",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4611",
      "conversations-prop-types": "static-1.7252",
      "conversations-visitor-message-history": "static-1.20416",
      "cssUtils": "static-1.731",
      "enviro": "static-4.405",
      "flux-actions": "static-1.309",
      "foundations-components": "static-1.7523",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5966",
      "hubspot-url-utils": "static-1.3957",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9436",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.367",
      "raven": "static-3.5725",
      "react": "static-7.177",
      "react-aria": "static-1.61",
      "react-dom": "static-7.85",
      "react-redux": "static-7.67",
      "react-rhumb": "static-1.16449",
      "react-utils": "static-2.5172",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.7940",
      "signup-constants": "static-1.18392",
      "styled-components": "static-2.85",
      "usage-tracker-multi": "static-1.5549",
      "visitor-ui-component-library-icons": "static-1.5742",
      "hs-promise-rejection-tracking": "static-1.5387",
      "raven-hubspot": "static-1.6032",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3227",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.81",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.77",
      "quartz-config": "static-1.515",
      "quartz-core": "static-1.5956",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4636",
      "foundations-theming": "static-1.4210",
      "UIComponents": "static-3.8175",
      "customer-data-email": "static-1.17669",
      "cv-backend-services": "static-1.1504",
      "immutable-less": "static-1.4454",
      "conversations-skeleton-state": "static-1.7048",
      "crm-events-viz-core": "static-1.32456",
      "customer-agent-discovery-components-lib": "static-1.2442",
      "customer-data-objects": "static-1.7450",
      "icons": "static-2.622",
      "react-input-autosize": "static-2.17",
      "react-router-dom": "static-5.26",
      "rpc-client-utils": "static-1.4434",
      "ui-images": "static-2.1091",
      "HeadJS": "static-2.710",
      "framer-motion": "static-1.67",
      "hs-test-utils-bend-plugin": "static-1.2917",
      "msw": "static-1.39",
      "testing-library": "static-1.147",
      "i18n-data": "static-1.216",
      "moment-timezone": "static-5.78",
      "jasmine": "static-4.4127",
      "signup-ui-url-generator": "static-2.7858",
      "HubStyle": "static-2.11536",
      "quartz-i18n": "static-1.412",
      "sassPrefix": "static-1.151",
      "bend-plugin-foundations-components": "static-1.3792",
      "floating-ui": "static-1.51",
      "foundations-theming-specialty": "static-1.1926",
      "hs-story-utils": "static-1.9228",
      "react-virtualized": "static-2.94",
      "tanstack-table": "static-1.50",
      "trellis-assets": "static-1.1190",
      "ui-fonts": "static-1.490",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3734",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5552",
      "bender-build-tools": "static-1.2947",
      "dispatcher": "static-1.132",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.794",
      "hubspotter-http": "static-1.4477",
      "mobile-manifest-mixins": "static-1.483",
      "module-federation": "static-1.18",
      "quartz-auth": "static-1.412",
      "quartz-head": "static-1.402",
      "quartz-routing": "static-1.167",
      "quartz-test": "static-1.412",
      "quartz-tracking": "static-1.116",
      "usage-tracker-container": "static-1.7125",
      "bend-plugin-foundations-theming": "static-1.2693",
      "foundations-theming-base": "static-1.3195",
      "stylex": "static-1.27",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4449",
      "customer-data-ui-utilities": "static-1.9624",
      "FileManagerCore": "static-1.38378",
      "FileManagerLib": "static-1.38519",
      "hubspot-apollo-client": "static-1.4681",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.520",
      "timezone-utils": "static-2.5044",
      "ui-gdpr-components": "static-1.10147",
      "ts-schema": "static-1.3903",
      "ai-components-ui-library": "static-1.8342",
      "avatar-components": "static-1.2285",
      "content-assistance-lib": "static-1.7448",
      "crm-component-utils": "static-1.38473",
      "crm-display-components": "static-1.24223",
      "crm-fe-perf": "static-1.22705",
      "crm-links": "static-1.6064",
      "crm-message-bus": "static-1.42356",
      "crm-search-service-types": "static-1.954",
      "crm-source-interpretation-lib": "static-1.5128",
      "customer-data-communicator": "static-1.44915",
      "customer-data-filters-ui": "static-1.38902",
      "customer-data-objects-ui-components": "static-1.12806",
      "customer-data-properties": "static-1.50793",
      "customer-data-rte": "static-1.32437",
      "draft-plugins": "static-2.21306",
      "file-manager-components": "static-1.22879",
      "framework-data-schema-resolvers": "static-1.6673",
      "frontend-preferences-client": "static-1.7725",
      "hubspot-prosemirror": "static-1.17596",
      "object-comments-thread-lib": "static-1.10076",
      "reference-resolvers-lite": "static-1.7894",
      "ui-addon-upgrades": "static-9.17652",
      "universal-associations-select": "static-1.10788",
      "final-form": "static-1.65",
      "ui-addon-video-player": "static-1.8496",
      "inbound-db-properties-service-client": "static-1.3674",
      "property-translator": "static-1.5213",
      "hub-http-shared-msw-handlers": "static-1.9474",
      "hubspotter-http-shared-msw-handlers": "static-1.9472",
      "react-dnd-compat": "static-1.4421",
      "audio-components": "static-1.5613",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.36030",
      "foundations-components-legacy": "static-1.548",
      "immerable": "static-1.3954",
      "ui-universal-auth": "static-1.8697",
      "video-components": "static-1.12556",
      "video-data-lib": "static-1.34211",
      "video-embed": "static-1.35045",
      "hubspot-apollo-cache": "static-1.140",
      "chatspot-core": "static-1.20302",
      "chirp-fetch": "static-1.1683",
      "ContentUtils": "static-1.67616",
      "copilot-toolkit": "static-1.10523",
      "superstore": "static-1.4570",
      "ui-coaching-tips": "static-1.27936",
      "card-properties-lib": "static-1.43513",
      "crm-actions": "static-1.6100",
      "crm-cards-data": "static-1.1205",
      "crm-cards-sdk": "static-1.42911",
      "customer-data-properties-shared-msw-handlers": "static-1.8801",
      "customer-data-property-utils": "static-1.7877",
      "customer-data-tracking": "static-1.6681",
      "inbound-db-meta-service-client": "static-1.3416",
      "framework-data-table": "static-2.11410",
      "location-customization-utils-lib": "static-1.8551",
      "calling-error-reporting": "static-1.31099",
      "calling-internal-common": "static-1.31093",
      "calling-usage-tracker": "static-1.6340",
      "crm_data": "static-4.91206",
      "customer-data-content": "static-1.26869",
      "draft-content-plugins": "static-1.27706",
      "draft-convert": "static-2.67",
      "draft-email-branding-plugin": "static-2.23694",
      "draft-extend": "static-3.70",
      "draft-js": "static-5.72",
      "draft-signature-plugin": "static-1.23507",
      "EmailSignatureEditor": "static-1.23904",
      "hubspot-prosemirror-plugins": "static-1.17588",
      "integration-settings-components": "static-1.14793",
      "integrations-lib": "static-1.15404",
      "integrations-tracking-lib": "static-1.5388",
      "native-integrations-shared-strings": "static-1.7588",
      "nav-meta": "static-1.28899",
      "onboarding-scopes": "static-1.6264",
      "outreach-assistant-email-generation": "static-1.5770",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.37268",
      "react-colorpicker": "static-2.10010",
      "reference-resolvers": "static-1.7961",
      "rich-text-lib": "static-1.19468",
      "sales-email-signature-service-client": "static-1.3645",
      "sequences-lib": "static-1.7689",
      "ui-addon-i18n": "static-1.10938",
      "ui-addon-iframeable": "static-1.8845",
      "ui-business-units-lib": "static-1.8826",
      "ui-shepherd-react": "static-3.9946",
      "user-context": "static-1.4899",
      "whatsapp-sending-lib": "static-1.4914",
      "customer-data-filters-ui-msw-helpers": "static-1.21337",
      "customer-data-reference-ui-components": "static-1.12944",
      "FormUrlGenerator": "static-2.4529",
      "framework-builder-read-service-client": "static-1.3832",
      "framework-data-schema-quick-fetch": "static-1.6578",
      "multi-account-reference-resolvers": "static-1.774",
      "onboarding-tours": "static-1.16257",
      "reporting-datasets-permissions-lib": "static-1.13030",
      "SharedI18nStrings": "static-1.180",
      "ui-addon-teams": "static-1.21241",
      "calling-global-api": "static-1.63656",
      "calling-lifecycle-internal": "static-1.65038",
      "calling-lifecycle-messages": "static-1.57332",
      "commerce-products-lib": "static-1.8857",
      "conditional-properties-service-client": "static-1.3622",
      "external-options-client-types": "static-1.3983",
      "google-libphonenumber": "static-1.33",
      "hs-entities": "static-1.478",
      "inbounddb-objects-service-types": "static-1.4048",
      "meetings-icalendar-utils-lib": "static-1.433",
      "multi-currency-client-types": "static-1.3516",
      "object-builder-ui-client": "static-1.47966",
      "pipeline-validation-client-types": "static-1.3785",
      "property-value-citations": "static-1.1407",
      "pulse": "static-1.312",
      "smart-property-lib": "static-1.5895",
      "tiered-pricing": "static-1.828",
      "ui-addon-form-validation": "static-1.10794",
      "video-components-external": "static-1.10553",
      "batch-promise": "static-1.1350",
      "crm-pipelines-api-client-types": "static-1.3963",
      "persist-promise": "static-1.3507",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24721",
      "knowledge-content-types": "static-1.8368",
      "payment-link-components": "static-1.22934",
      "ui-addon-emoji-picker": "static-1.9689",
      "call-summary": "static-1.38347",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9620",
      "laboratory-lib": "static-3.6961",
      "merchandise-lib": "static-1.259",
      "purchase-motions-components": "static-1.5483",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.492",
      "content-icons-ui": "static-1.2153",
      "social-insights-client-types": "static-1.21316",
      "outpost": "static-1.4004",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4607",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5394",
      "magpie-types": "static-1.4854",
      "simple-logging-lib": "static-1.2850",
      "growth-onboarding-feedback-components": "static-1.6384",
      "customer-data-sidebar": "static-2.45411",
      "enrichment-properties-lib": "static-1.15013",
      "customer-data-associations": "static-1.7137",
      "deal-intel-decorators": "static-1.1251",
      "reporting-data": "static-1.66503",
      "tanstack-virtual": "static-1.25",
      "ui-addon-draggable": "static-3.4566",
      "crm-record-cards-service-types": "static-1.3451",
      "self-service-api": "static-1.10033",
      "crm_universal": "static-1.21660",
      "SalesContentIndexUI": "static-3.8900",
      "signup-ui-lego-core": "static-1.20402",
      "content-embed-lib": "static-1.7140",
      "data-model-builder-lib": "static-1.11636",
      "remote-ui": "static-1.60",
      "ui-components-test-utils": "static-1.5366",
      "ui-extensions-remote-renderer": "static-1.16356",
      "universal-page-editor-lib": "static-1.2799",
      "integrations-error-boundary-lib": "static-1.12819",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10172",
      "rxjs": "static-5.10",
      "messaging-types-lib": "static-1.45380",
      "data-token-picker": "static-1.16041",
      "sequences-client-types-lib": "static-1.7546",
      "foundations-components-test-utils": "static-1.5006",
      "navigation-messaging": "static-1.6589",
      "getting-started-shared-tasks": "static-1.17875",
      "getting-started-shared-tasks-store": "static-1.16993",
      "onboarding-tours-utils": "static-1.323",
      "messaging-usage-based-billing-components-lib": "static-1.505",
      "whatsapp-management-lib": "static-1.8073",
      "growth-data-modal": "static-1.5156",
      "growth-onboarding-confetti": "static-1.2871",
      "growth-onboarding-next-action-utils": "static-1.1299",
      "navigation-components": "static-1.17262",
      "onboarding-tours-client": "static-1.4471",
      "ui-shepherd-tracker": "static-1.7327",
      "shared-worker-versioning": "static-1.10838",
      "voice-sms-access-library": "static-1.238",
      "commerce-permissions": "static-1.557",
      "products-iframe-lib": "static-1.7308",
      "products-ui-components-shared-msw-handlers": "static-1.9856",
      "directed-graph": "static-1.737",
      "event-emitter": "static-1.747",
      "breeze-intelligence-kit": "static-1.5322",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9557",
      "fsm": "static-1.3530",
      "policy-lib": "static-1.6585",
      "react-tinymce": "static-1.54611",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53737",
      "tinymce-plugins": "static-1.56851",
      "tinymce-themes": "static-1.55707",
      "content-media-composition-data-lib": "static-1.11445",
      "content-media-compositions": "static-2.15452",
      "idb-keyval": "static-1.39",
      "media-bridge-lib": "static-1.18563",
      "ui-addon-opt": "static-4.8184",
      "commerce-tours-lib": "static-1.5718",
      "growth-onboarding-reliability": "static-1.4886",
      "sales-checkout-service-client": "static-1.3468",
      "ai-addon-copilot-preview": "static-1.7554",
      "calling-cross-tab-library": "static-1.19070",
      "calling-lifecycle-usage-tracker": "static-1.8126",
      "wootric-nps": "static-1.6783",
      "growth-monetization-service-types": "static-1.4314",
      "nav-client-types": "static-1.2157",
      "purchase-motions-api": "static-1.5486",
      "trials-service-types": "static-1.3715",
      "reactive-lib": "static-1.525",
      "card-payment-highlight-lib": "static-1.36495",
      "card-subscription-highlight-lib": "static-1.38852",
      "commerce-billing-lib": "static-1.18495",
      "commerce-contract-lib": "static-1.11184",
      "invoices-highlight-card-lib": "static-1.54020",
      "orders-highlight-card-lib": "static-1.20863",
      "products-highlight-card-lib": "static-1.17141",
      "project-storage": "static-1.4533",
      "quotes-highlight-card-lib": "static-1.71180",
      "usage-based-billing-components-lib": "static-1.7994",
      "deal-intel-utils": "static-1.1255",
      "storybook-react": "static-1.28",
      "reporting-client-types": "static-1.2385",
      "react-flip-move": "static-1.65",
      "FireAlarmUi": "static-1.4328",
      "sales-templates-service-types-lib": "static-1.3990",
      "ui-asset-management-lib": "static-1.10707",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.9642",
      "collaboration-sidebar": "static-1.57112",
      "conditional-property-settings-modal": "static-1.11944",
      "data-model-commons-lib": "static-1.11938",
      "feedback-loader": "static-1.28853",
      "html-to-image": "static-1.49",
      "object-definition-builder-lib": "static-1.6867",
      "property-management-iframe": "static-1.12335",
      "property-usages-lib": "static-1.5194",
      "reactflow": "static-1.59",
      "simple-data-table": "static-1.2179",
      "used-in-list-lib": "static-1.6722",
      "visual-association": "static-1.5650",
      "highcharts": "static-8.99",
      "reporting-visualizations": "static-1.58579",
      "ui-extensibility-client-types": "static-1.3744",
      "automation-platform-service-types": "static-1.2491",
      "ContentData": "static-1.67691",
      "email-portal-health-service-types": "static-1.774",
      "marketing-email-service-types": "static-1.1771",
      "messaging-user-info-utils-lib": "static-1.124",
      "content-whatsapp-service-types": "static-1.262",
      "marketing-platform-lib": "static-1.6639",
      "short-messages-app-service-client": "static-1.3812",
      "ui-tool-access": "static-1.9945",
      "growth-onboarding-next-action-components": "static-1.1327",
      "calling-orchestration-schema": "static-1.35015",
      "sales-views-client-types": "static-1.4087",
      "trellis-story-utils": "static-1.4322",
      "hub-http-contrib": "static-1.2844",
      "interframe": "static-3.4590",
      "tinymce-data": "static-1.39822",
      "ui-addon-sales-email": "static-1.5014",
      "codemirror": "static-5.90",
      "layout-dnd-components": "static-1.12032",
      "layout-dnd-utils": "static-1.11007",
      "react-codemirror": "static-1.10426",
      "ui-brand-identity-lib": "static-1.13874",
      "NamespacedHubStyle": "static-2.8895",
      "hls.js": "static-1.34",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.9300",
      "ai-settings-ui-library": "static-1.7456",
      "copilot-plugins": "static-1.10496",
      "eligibility-engine-service-types": "static-1.2996",
      "commerce-shared-components-lib": "static-1.17909",
      "commerce-subscription-lib": "static-1.36429",
      "commerce-tools-ui-lib": "static-1.9785",
      "usage-tracker-session-replay": "static-1.4821",
      "utility-belt": "static-1.2341",
      "payments-enrollment-embed-lib": "static-1.22017",
      "products-ui-components": "static-1.39376",
      "quotes-ui-lib": "static-1.79899",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6723",
      "invoices-ui-lib": "static-1.54036",
      "commerce-products-api": "static-1.1956",
      "SafeStorage": "static-1.4205",
      "invoices-iframe-lib": "static-1.56094",
      "quotes-modal-lib": "static-1.101856",
      "platform-infra-nav-components": "static-1.7491",
      "reporting-ui-components": "static-2.63774",
      "subscription-experience-data-types": "static-1.14586",
      "association-translator": "static-1.2992",
      "crm-settings-header-lib": "static-1.8116",
      "settings-ui-nav": "static-2.9977",
      "chatspot-widget-iframe": "static-1.20294",
      "collaboration-sidebar-common": "static-1.1909",
      "crm-properties-common-lib": "static-1.5672",
      "ui-addon-draggable-compat": "static-2.4053",
      "property-management-common": "static-1.4622",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14814",
      "advanced-menus-lib": "static-1.11788",
      "ExportDialog": "static-6.10187",
      "ui-memberships-settings-lib": "static-1.33420",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9332",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.13517",
      "highlight.js": "static-1.74",
      "reporting-action-components": "static-1.40650",
      "reporting-snowflake": "static-1.55121",
      "ui-addon-react-router-dom": "static-1.9347",
      "growth-onboarding-empty-states": "static-1.5364",
      "InboxConnectUtils": "static-4.14218",
      "payments-post-enroll-local-storage-lib": "static-1.4912",
      "qrcode-generator": "static-1.64",
      "amplitude-session-replay-browser": "static-1.55",
      "marketplace-ui-apps-core": "static-1.17468",
      "stripe-embedded-components": "static-1.7132",
      "commerce-tax-lib": "static-1.317",
      "property-description-translator": "static-1.3659",
      "commerce-analytics-service-client": "static-1.3456",
      "totals-ui-components": "static-1.22991",
      "reporting-plugins": "static-1.9982",
      "reporting-reports": "static-1.66181",
      "edison-service-client-types": "static-1.190",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14813",
      "simple-menus-lib": "static-1.16330",
      "academy-common-lib": "static-1.12977",
      "dashboard-lib": "static-1.80616",
      "share-with-third-party-component-lib": "static-1.8491",
      "developer-experience-shared-components": "static-1.10261",
      "marketplace-ui-client-types": "static-1.16342",
      "marketplace-ui-common": "static-1.18935",
      "ui-addon-integrations-directory-panel": "static-2.7789",
      "stripe-connect-js": "static-1.64",
      "commerce-totals-service-types": "static-1.3636",
      "campaign-roi-lib": "static-1.8265",
      "academy-service-client": "static-1.3480",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3677",
      "oauth-service-types": "static-1.4042",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.28316",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9479",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4516",
      "atom": "/atom/static-1.4869",
      "conversations-async-data": "/conversations-async-data/static-2.7462",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8676",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15766",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12482",
      "conversations-message-history": "/conversations-message-history/static-1.12024",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10298",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.21679",
      "head-dlb": "/head-dlb/static-1.4841",
      "hs-promise-utils": "/hs-promise-utils/static-1.5393",
      "hs-test-utils": "/hs-test-utils/static-1.7806",
      "hubspot-dlb": "/hubspot-dlb/static-2.1806",
      "HubStyleTokens": "/HubStyleTokens/static-2.11228",
      "I18n": "/I18n/static-7.1569",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2818",
      "jasmine-runner": "/jasmine-runner/static-1.6273",
      "quartz": "/quartz/static-1.6737",
      "react-dlb": "/react-dlb/static-1.71",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.60",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4274",
      "StyleGuideUI": "/StyleGuideUI/static-3.483",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4333",
      "usage-tracker": "/usage-tracker/static-1.7135",
      "usage-tracker-core": "/usage-tracker-core/static-1.6985",
      "usage-tracker-public": "/usage-tracker-public/static-1.6946",
      "viral-links-lib": "/viral-links-lib/static-1.6834",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5931",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4611",
      "conversations-prop-types": "/conversations-prop-types/static-1.7252",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.20416",
      "cssUtils": "/cssUtils/static-1.731",
      "enviro": "/enviro/static-4.405",
      "flux-actions": "/flux-actions/static-1.309",
      "foundations-components": "/foundations-components/static-1.7523",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5966",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9436",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.367",
      "raven": "/raven/static-3.5725",
      "react": "/react/static-7.177",
      "react-aria": "/react-aria/static-1.61",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.67",
      "react-rhumb": "/react-rhumb/static-1.16449",
      "react-utils": "/react-utils/static-2.5172",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.7940",
      "signup-constants": "/signup-constants/static-1.18392",
      "styled-components": "/styled-components/static-2.85",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5549",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5742",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
      "raven-hubspot": "/raven-hubspot/static-1.6032",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3227",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.77",
      "quartz-config": "/quartz-config/static-1.515",
      "quartz-core": "/quartz-core/static-1.5956",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4636",
      "foundations-theming": "/foundations-theming/static-1.4210",
      "UIComponents": "/UIComponents/static-3.8175",
      "customer-data-email": "/customer-data-email/static-1.17669",
      "cv-backend-services": "/cv-backend-services/static-1.1504",
      "immutable-less": "/immutable-less/static-1.4454",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7048",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.32456",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2442",
      "customer-data-objects": "/customer-data-objects/static-1.7450",
      "icons": "/icons/static-2.622",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-router-dom": "/react-router-dom/static-5.26",
      "rpc-client-utils": "/rpc-client-utils/static-1.4434",
      "ui-images": "/ui-images/static-2.1091",
      "HeadJS": "/HeadJS/static-2.710",
      "framer-motion": "/framer-motion/static-1.67",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2917",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.147",
      "i18n-data": "/i18n-data/static-1.216",
      "moment-timezone": "/moment-timezone/static-5.78",
      "jasmine": "/jasmine/static-4.4127",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
      "HubStyle": "/HubStyle/static-2.11536",
      "quartz-i18n": "/quartz-i18n/static-1.412",
      "sassPrefix": "/sassPrefix/static-1.151",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3792",
      "floating-ui": "/floating-ui/static-1.51",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1926",
      "hs-story-utils": "/hs-story-utils/static-1.9228",
      "react-virtualized": "/react-virtualized/static-2.94",
      "tanstack-table": "/tanstack-table/static-1.50",
      "trellis-assets": "/trellis-assets/static-1.1190",
      "ui-fonts": "/ui-fonts/static-1.490",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3734",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5552",
      "bender-build-tools": "/bender-build-tools/static-1.2947",
      "dispatcher": "/dispatcher/static-1.132",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.794",
      "hubspotter-http": "/hubspotter-http/static-1.4477",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.483",
      "module-federation": "/module-federation/static-1.18",
      "quartz-auth": "/quartz-auth/static-1.412",
      "quartz-head": "/quartz-head/static-1.402",
      "quartz-routing": "/quartz-routing/static-1.167",
      "quartz-test": "/quartz-test/static-1.412",
      "quartz-tracking": "/quartz-tracking/static-1.116",
      "usage-tracker-container": "/usage-tracker-container/static-1.7125",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2693",
      "foundations-theming-base": "/foundations-theming-base/static-1.3195",
      "stylex": "/stylex/static-1.27",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4449",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9624",
      "FileManagerCore": "/FileManagerCore/static-1.38378",
      "FileManagerLib": "/FileManagerLib/static-1.38519",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4681",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.520",
      "timezone-utils": "/timezone-utils/static-2.5044",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10147",
      "ts-schema": "/ts-schema/static-1.3903",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8342",
      "avatar-components": "/avatar-components/static-1.2285",
      "content-assistance-lib": "/content-assistance-lib/static-1.7448",
      "crm-component-utils": "/crm-component-utils/static-1.38473",
      "crm-display-components": "/crm-display-components/static-1.24223",
      "crm-fe-perf": "/crm-fe-perf/static-1.22705",
      "crm-links": "/crm-links/static-1.6064",
      "crm-message-bus": "/crm-message-bus/static-1.42356",
      "crm-search-service-types": "/crm-search-service-types/static-1.954",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5128",
      "customer-data-communicator": "/customer-data-communicator/static-1.44915",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38902",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12806",
      "customer-data-properties": "/customer-data-properties/static-1.50793",
      "customer-data-rte": "/customer-data-rte/static-1.32437",
      "draft-plugins": "/draft-plugins/static-2.21306",
      "file-manager-components": "/file-manager-components/static-1.22879",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6673",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7725",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17596",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10076",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7894",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17652",
      "universal-associations-select": "/universal-associations-select/static-1.10788",
      "final-form": "/final-form/static-1.65",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8496",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3674",
      "property-translator": "/property-translator/static-1.5213",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9474",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9472",
      "react-dnd-compat": "/react-dnd-compat/static-1.4421",
      "audio-components": "/audio-components/static-1.5613",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.36030",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.548",
      "immerable": "/immerable/static-1.3954",
      "ui-universal-auth": "/ui-universal-auth/static-1.8697",
      "video-components": "/video-components/static-1.12556",
      "video-data-lib": "/video-data-lib/static-1.34211",
      "video-embed": "/video-embed/static-1.35045",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.140",
      "chatspot-core": "/chatspot-core/static-1.20302",
      "chirp-fetch": "/chirp-fetch/static-1.1683",
      "ContentUtils": "/ContentUtils/static-1.67616",
      "copilot-toolkit": "/copilot-toolkit/static-1.10523",
      "superstore": "/superstore/static-1.4570",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27936",
      "card-properties-lib": "/card-properties-lib/static-1.43513",
      "crm-actions": "/crm-actions/static-1.6100",
      "crm-cards-data": "/crm-cards-data/static-1.1205",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42911",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8801",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7877",
      "customer-data-tracking": "/customer-data-tracking/static-1.6681",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3416",
      "framework-data-table": "/framework-data-table/static-2.11410",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8551",
      "calling-error-reporting": "/calling-error-reporting/static-1.31099",
      "calling-internal-common": "/calling-internal-common/static-1.31093",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6340",
      "crm_data": "/crm_data/static-4.91206",
      "customer-data-content": "/customer-data-content/static-1.26869",
      "draft-content-plugins": "/draft-content-plugins/static-1.27706",
      "draft-convert": "/draft-convert/static-2.67",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23694",
      "draft-extend": "/draft-extend/static-3.70",
      "draft-js": "/draft-js/static-5.72",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23507",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23904",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17588",
      "integration-settings-components": "/integration-settings-components/static-1.14793",
      "integrations-lib": "/integrations-lib/static-1.15404",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5388",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7588",
      "nav-meta": "/nav-meta/static-1.28899",
      "onboarding-scopes": "/onboarding-scopes/static-1.6264",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5770",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.37268",
      "react-colorpicker": "/react-colorpicker/static-2.10010",
      "reference-resolvers": "/reference-resolvers/static-1.7961",
      "rich-text-lib": "/rich-text-lib/static-1.19468",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3645",
      "sequences-lib": "/sequences-lib/static-1.7689",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10938",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8845",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8826",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9946",
      "user-context": "/user-context/static-1.4899",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4914",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21337",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12944",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4529",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3832",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6578",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.774",
      "onboarding-tours": "/onboarding-tours/static-1.16257",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13030",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
      "ui-addon-teams": "/ui-addon-teams/static-1.21241",
      "calling-global-api": "/calling-global-api/static-1.63656",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65038",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57332",
      "commerce-products-lib": "/commerce-products-lib/static-1.8857",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3622",
      "external-options-client-types": "/external-options-client-types/static-1.3983",
      "google-libphonenumber": "/google-libphonenumber/static-1.33",
      "hs-entities": "/hs-entities/static-1.478",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4048",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.433",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3516",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47966",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3785",
      "property-value-citations": "/property-value-citations/static-1.1407",
      "pulse": "/pulse/static-1.312",
      "smart-property-lib": "/smart-property-lib/static-1.5895",
      "tiered-pricing": "/tiered-pricing/static-1.828",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10794",
      "video-components-external": "/video-components-external/static-1.10553",
      "batch-promise": "/batch-promise/static-1.1350",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3963",
      "persist-promise": "/persist-promise/static-1.3507",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24721",
      "knowledge-content-types": "/knowledge-content-types/static-1.8368",
      "payment-link-components": "/payment-link-components/static-1.22934",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9689",
      "call-summary": "/call-summary/static-1.38347",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9620",
      "laboratory-lib": "/laboratory-lib/static-3.6961",
      "merchandise-lib": "/merchandise-lib/static-1.259",
      "purchase-motions-components": "/purchase-motions-components/static-1.5483",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.492",
      "content-icons-ui": "/content-icons-ui/static-1.2153",
      "social-insights-client-types": "/social-insights-client-types/static-1.21316",
      "outpost": "/outpost/static-1.4004",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4607",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5394",
      "magpie-types": "/magpie-types/static-1.4854",
      "simple-logging-lib": "/simple-logging-lib/static-1.2850",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6384",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45411",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15013",
      "customer-data-associations": "/customer-data-associations/static-1.7137",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.1251",
      "reporting-data": "/reporting-data/static-1.66503",
      "tanstack-virtual": "/tanstack-virtual/static-1.25",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4566",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3451",
      "self-service-api": "/self-service-api/static-1.10033",
      "crm_universal": "/crm_universal/static-1.21660",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8900",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20402",
      "content-embed-lib": "/content-embed-lib/static-1.7140",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.11636",
      "remote-ui": "/remote-ui/static-1.60",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5366",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16356",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2799",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12819",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10172",
      "rxjs": "/rxjs/static-5.10",
      "messaging-types-lib": "/messaging-types-lib/static-1.45380",
      "data-token-picker": "/data-token-picker/static-1.16041",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7546",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5006",
      "navigation-messaging": "/navigation-messaging/static-1.6589",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17875",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16993",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.323",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.505",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.8073",
      "growth-data-modal": "/growth-data-modal/static-1.5156",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2871",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1299",
      "navigation-components": "/navigation-components/static-1.17262",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4471",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7327",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10838",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.238",
      "commerce-permissions": "/commerce-permissions/static-1.557",
      "products-iframe-lib": "/products-iframe-lib/static-1.7308",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9856",
      "directed-graph": "/directed-graph/static-1.737",
      "event-emitter": "/event-emitter/static-1.747",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5322",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9557",
      "fsm": "/fsm/static-1.3530",
      "policy-lib": "/policy-lib/static-1.6585",
      "react-tinymce": "/react-tinymce/static-1.54611",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53737",
      "tinymce-plugins": "/tinymce-plugins/static-1.56851",
      "tinymce-themes": "/tinymce-themes/static-1.55707",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11445",
      "content-media-compositions": "/content-media-compositions/static-2.15452",
      "idb-keyval": "/idb-keyval/static-1.39",
      "media-bridge-lib": "/media-bridge-lib/static-1.18563",
      "ui-addon-opt": "/ui-addon-opt/static-4.8184",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5718",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4886",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3468",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7554",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19070",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8126",
      "wootric-nps": "/wootric-nps/static-1.6783",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4314",
      "nav-client-types": "/nav-client-types/static-1.2157",
      "purchase-motions-api": "/purchase-motions-api/static-1.5486",
      "trials-service-types": "/trials-service-types/static-1.3715",
      "reactive-lib": "/reactive-lib/static-1.525",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36495",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38852",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18495",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.11184",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54020",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20863",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17141",
      "project-storage": "/project-storage/static-1.4533",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71180",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7994",
      "deal-intel-utils": "/deal-intel-utils/static-1.1255",
      "storybook-react": "/storybook-react/static-1.28",
      "reporting-client-types": "/reporting-client-types/static-1.2385",
      "react-flip-move": "/react-flip-move/static-1.65",
      "FireAlarmUi": "/FireAlarmUi/static-1.4328",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3990",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10707",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.9642",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57112",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.11944",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11938",
      "feedback-loader": "/feedback-loader/static-1.28853",
      "html-to-image": "/html-to-image/static-1.49",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6867",
      "property-management-iframe": "/property-management-iframe/static-1.12335",
      "property-usages-lib": "/property-usages-lib/static-1.5194",
      "reactflow": "/reactflow/static-1.59",
      "simple-data-table": "/simple-data-table/static-1.2179",
      "used-in-list-lib": "/used-in-list-lib/static-1.6722",
      "visual-association": "/visual-association/static-1.5650",
      "highcharts": "/highcharts/static-8.99",
      "reporting-visualizations": "/reporting-visualizations/static-1.58579",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3744",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2491",
      "ContentData": "/ContentData/static-1.67691",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.774",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1771",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.124",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.262",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6639",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3812",
      "ui-tool-access": "/ui-tool-access/static-1.9945",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1327",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35015",
      "sales-views-client-types": "/sales-views-client-types/static-1.4087",
      "trellis-story-utils": "/trellis-story-utils/static-1.4322",
      "hub-http-contrib": "/hub-http-contrib/static-1.2844",
      "interframe": "/interframe/static-3.4590",
      "tinymce-data": "/tinymce-data/static-1.39822",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5014",
      "codemirror": "/codemirror/static-5.90",
      "layout-dnd-components": "/layout-dnd-components/static-1.12032",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11007",
      "react-codemirror": "/react-codemirror/static-1.10426",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13874",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8895",
      "hls.js": "/hls.js/static-1.34",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.9300",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7456",
      "copilot-plugins": "/copilot-plugins/static-1.10496",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2996",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17909",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36429",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9785",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4821",
      "utility-belt": "/utility-belt/static-1.2341",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22017",
      "products-ui-components": "/products-ui-components/static-1.39376",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79899",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6723",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.54036",
      "commerce-products-api": "/commerce-products-api/static-1.1956",
      "SafeStorage": "/SafeStorage/static-1.4205",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56094",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.101856",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7491",
      "reporting-ui-components": "/reporting-ui-components/static-2.63774",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14586",
      "association-translator": "/association-translator/static-1.2992",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.8116",
      "settings-ui-nav": "/settings-ui-nav/static-2.9977",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20294",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1909",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5672",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4053",
      "property-management-common": "/property-management-common/static-1.4622",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14814",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11788",
      "ExportDialog": "/ExportDialog/static-6.10187",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33420",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9332",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.13517",
      "highlight.js": "/highlight.js/static-1.74",
      "reporting-action-components": "/reporting-action-components/static-1.40650",
      "reporting-snowflake": "/reporting-snowflake/static-1.55121",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9347",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5364",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14218",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4912",
      "qrcode-generator": "/qrcode-generator/static-1.64",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17468",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7132",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.317",
      "property-description-translator": "/property-description-translator/static-1.3659",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3456",
      "totals-ui-components": "/totals-ui-components/static-1.22991",
      "reporting-plugins": "/reporting-plugins/static-1.9982",
      "reporting-reports": "/reporting-reports/static-1.66181",
      "edison-service-client-types": "/edison-service-client-types/static-1.190",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14813",
      "simple-menus-lib": "/simple-menus-lib/static-1.16330",
      "academy-common-lib": "/academy-common-lib/static-1.12977",
      "dashboard-lib": "/dashboard-lib/static-1.80616",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8491",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10261",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16342",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18935",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7789",
      "stripe-connect-js": "/stripe-connect-js/static-1.64",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3636",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.8265",
      "academy-service-client": "/academy-service-client/static-1.3480",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3677",
      "oauth-service-types": "/oauth-service-types/static-1.4042",
      "react-window": "/react-window/static-1.13"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.28316",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};